import React from 'react'
import styled from 'styled-components'
import { Text, View } from '../../../../../styles'
import Float from '../../../../../styles/float/Float'
import Outer from '../../../../../styles/outer/Outer'

const CardItemComponent: React.FC<any> = ({ id, title, platform, icon, content, ...props }) => {
  return (
    <Wrap>
      <StyledCard>
        <View direction='column'>
          <StyleContent>
            <div className='inner'>
              <Text size='xs' color='gray-color-300'>
                {content}
              </Text>
            </div>
            <img className='icon' src={icon} />
          </StyleContent>
          <StyledTitle>
            <View direction='column' spacing={6}>
              <Text size='xl'>{title}</Text>
              <Text size='xs'>{platform}</Text>
            </View>
          </StyledTitle>
        </View>
      </StyledCard>
    </Wrap>
  )
}

export default CardItemComponent

const Wrap = styled.div`
  height: 430px;
`

const StyledCard = styled.div`
  margin: 0 auto;
  width: 90%;
  height: 382px;
  border-radius: 15px;
  box-shadow: 0px 15px 15px 0 rgba(0, 0, 0, 0.1);
`

const StyleContent = styled.div`
  position: relative;
  width: 100%;
  min-height: 255px;
  height: 255px;
  max-height: 255px;
  padding: 24px 29px 30px 29px;
  background-color: #d8e0e7;
  border-radius: 15px 15px 0 0;
  z-index: 20;

  .inner {
    /* max-width: 281px; */
    /* max-height: 192px; */
    word-break: break-all;
  }

  .icon {
    position: absolute;
    top: 61%;
    height: auto;
    right: -17px;
    width: 194px;
    height: 194px;
  }
`

const StyledTitle = styled.div`
  width: 100%;
  height: 126px;
  padding-top: 28px;
  padding-left: 28px;
  background-color: var(--white-color);
  border-radius: 0 0 15px 15px;
`
